import { read, utils } from "xlsx";
/*
 * Because of an issue described here https://github.com/SheetJS/sheetjs/issues/1565 (and other tickets)
 * Date coming from excel is always a few seconds off. We try to fix it
 */
const fixDateFromExcel = (date) => {
    const fix = new Date(date);
    if (date instanceof Date) {
        fix.setMinutes(fix.getMinutes() + 2);
    }
    return new Date(Date.UTC(fix.getFullYear(), fix.getMonth(), fix.getDate()));
};
export const getExcelRows = (content, sheetIndex = 0) => new Promise((resolve) => {
    const readExcel = (file) => {
        const workbook = read(file, { cellDates: true, type: "binary" });
        const sheetNames = workbook.SheetNames;
        const worksheet = workbook.Sheets[sheetNames[sheetIndex]];
        const rows = utils.sheet_to_json(worksheet);
        for (const row of rows) {
            for (const [key, value] of Object.entries(row)) {
                if (value instanceof Date) {
                    row[key] = fixDateFromExcel(value);
                }
            }
        }
        resolve(rows);
    };
    const reader = new FileReader();
    reader.onload = () => reader.result && readExcel(reader.result);
    reader.readAsBinaryString(content);
});
